
import axios from '../../http/config'
//初始化数据
const state = {
    recruitList: [1,2],
    totalPage:0
}

//getter 抛出去的数据
const getters = {
    recruitList:state => state.recruitList,
    totalPage:state => state.totalPage

}

//action 异步的操作
const actions = {
    recruitListFn({commit},data){
      axios.get(`/outer/recruit/listRecruits.do`, {
        "page.currPage":data,
        "page.count":10
      }).then((res)=>{
        commit('recruitListm',res.data.list);
        commit('totalPagem',res.data.totalPage*10)
      })
    }
}

//mutation
const mutations = {
    recruitListm(state,data){
      state.recruitList = data
    },
    totalPagem(state,data){
      state.totalPage = data
    }
}


export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
  };



// WEBPACK FOOTER //
// ./src/store/modules/recruit.js